import React from 'react';

import { ProductReferences } from 'common/constants/enums';
import { EphemeralStateProvider } from 'components/EphemeralStateProvider';
import { CrossPlatformThemeProvider } from 'components/ProvidersContainer/ProductThemeProvider';
import { getThemeForProduct } from 'config/getThemeForProducts';
import { addStory } from 'lib/story-books';
import { useFakeStorybookSceneSet } from 'lib/story-books/useFakeStorybookSceneSet';

import { Form } from '..';

import { payload } from '.';

const Story = () => {
  const sceneSets = useFakeStorybookSceneSet();
  if (!sceneSets) {
    return null;
  }
  return (
    <Form
      fieldProps={{
        sd2: { hidden: true },
        sd4: { hidden: true },
        sd6: { hidden: true },
      }}
      {...payload}
    />
  );
};

addStory('sleep-diary/Form hidden', () => (
  <EphemeralStateProvider>
    <CrossPlatformThemeProvider
      theme={getThemeForProduct(ProductReferences.SLEEPIO)}
    >
      <Story />
    </CrossPlatformThemeProvider>
  </EphemeralStateProvider>
));
